import { Component, h, Prop, Host, Watch, State } from '@stencil/core';
import { ProductPriceItem } from './pn-find-price-types';
import { state } from './pn-find-price-store';
import { sendDirectUrl, stampShopUrl, RealValues } from './data.js';
import { bolt, box_label, map_marker } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-find-price-result',
  styleUrl: 'pn-find-price-result.scss',
})
export class PnfindPriceResult {
  @Prop({ mutable: true }) item: ProductPriceItem = null;

  @Prop() shownitems: ProductPriceItem[] = [];
  @Prop() Usp1?: string;
  @Prop() Usp2?: string;
  @Prop() Usp3?: string;
  @Prop() description?: string[] = [];
  @Prop() showMeasurement?: boolean = false;
  @State() weightText = '';
  @State() linkId: string = '';
  @State() shopLabel: string = '';
  @State() shopUrl: string = '';
  @State() shopId: string = '';

  componentWillLoad() {
    this.composeItems();
  }

  @Watch('item')
  composeItems() {
    if (this.item.additionalusp) {
      var x = this.item.additionalusp.split('/');
      this.Usp1 = x.length > 0 ? x[0] : null;
      this.Usp2 = x.length > 1 ? x[1] : null;
      this.Usp3 = x.length > 2 ? x[2] : null;
    }
    if (this.item.description) {
      this.description = this.item.description.split('#bullet').filter(x => x !== '');
    }

    this.showMeasurement = this.item.maxmått !== null || this.item.rulle !== null;
    this.linkId = `${this.item.id}-${this.item.maxweight}-${this.item.sizecategory}-${this.item.name.toLocaleLowerCase().replace(/[^a-zA-Z0-9]/g, '')}`;

    var showServicepointLink = this.item.ombudpurchase === 'Yes';

    this.shopLabel = showServicepointLink ? state.i18n.ombudHeader : state.i18n.stampshopcta;
    this.shopUrl = showServicepointLink ? state.market.servicePoint : stampShopUrl;
    this.shopId = showServicepointLink ? '-servicepoint' : '-stampshop';
  }

  render() {
    return (
      <Host>
        {
          <pn-product-card data-productid={this.item.id}>
            <pn-illustration slot="illustration" illustration={this.item.illustration}></pn-illustration>
            <div slot="title">
              {this.item.infopagelink ? (
                <h2>
                  <a href={this.item.infopagelink} target="_blank">
                    {this.item.name}
                  </a>
                </h2>
              ) : (
                <h2>{this.item.name}</h2>
              )}
              {this.item.highestrankusp === 'Snabbast' ? (
                <pn-titletag slot="Snabbast" icon={bolt} color="blue700">
                  {this.item.highestrankusp}
                </pn-titletag>
              ) : this.item.highestrankusp === 'Billigast' ? (
                <pn-titletag slot="Billigast" icon={box_label} color="green700">
                  {this.item.highestrankusp}
                </pn-titletag>
              ) : null}
            </div>
            <div slot="content">
              <div class="content">
                {this.item.description ? (
                  <div class="description">
                    {this.description.map(desc => (
                      <li>{desc}</li>
                    ))}
                  </div>
                ) : null}
                {this.item.info ? <div class="description">{this.item.info}</div> : null}
              </div>
            </div>
            {this.item.note ? (
              <div slot="note">
                <p>{this.item.note}</p>
              </div>
            ) : null}
            {this.item.additionalusp ? (
              <div slot="additionalUSP">
                {this.Usp1 ? <span>{this.Usp1}</span> : null}
                {this.Usp2 ? <span>{this.Usp2}</span> : null}
                {this.Usp3 ? <span>{this.Usp3}</span> : null}
              </div>
            ) : null}
            {this.showMeasurement ? <pn-product-card-info paket={this.item.maxmått} rulle={this.item.rulle}></pn-product-card-info> : null}
            <div slot="cardprice">
              {this.item.pricesenddirect ? (
                <pn-product-card-price
                  slot="sendDirectPrice"
                  label={state.i18n.senddirectcta}
                  amount={this.item.pricesenddirect + ''}
                  currency={state.market.currency}
                  url={sendDirectUrl}
                  linkid={this.linkId + '-portal'}
                ></pn-product-card-price>
              ) : null}
              {this.item.pricestamps ? (
                this.item.name.toLocaleLowerCase() !== 'riktiga vykort' ? (
                  <pn-product-card-price
                    slot="stampPrice"
                    label={this.shopLabel}
                    amount={this.item.pricestamps + ''}
                    currency={state.market.currency}
                    url={this.shopUrl}
                    linkid={this.linkId + this.shopId}
                  ></pn-product-card-price>
                ) : (
                  <pn-product-card-price
                    slot="riktiga"
                    label={state.i18n.realPostcard}
                    amount={this.item.pricestamps + ''}
                    currency={state.market.currency}
                    url={RealValues['WebUrl']}
                    linkid={this.linkId + '-riktiga'}
                  ></pn-product-card-price>
                )
              ) : null}
            </div>
            <div slot="servicepoint">
              {this.item.showservicepointlink ? (
                <a href={state.market.servicePoint} target="_blank">
                  <pn-icon icon={map_marker} color="blue700"></pn-icon>
                  {state.i18n.servicePointLink}
                </a>
              ) : null}
            </div>

            <div slot="mobiledownload">
              {this.item.name.toLocaleLowerCase() === 'riktiga vykort' ? (
                <div id="riktiga">
                  <h4>{state.i18n.realPostcardMobile}</h4>
                  <div>
                    <a href={RealValues['AndroidAppUrl']} target="_blank">
                      <img class="riktigaAndroidImg" src={RealValues['AndroidImg']}></img>
                    </a>
                    <a href={RealValues['IosAppUrl']} target="_blank">
                      <img class="riktigaAppleImg" src={RealValues['IosImg']}></img>
                    </a>
                  </div>
                </div>
              ) : null}
            </div>
          </pn-product-card>
        }
      </Host>
    );
  }
}
